import InboxService from '~/services/inbox.service';
import * as inboxDb from '~/lib/indexedDb/inbox';
import {  gameSelectors } from '~/store/selectors';
// ---- internal imports ----

import * as types from '../actionTypes';
// ---- parent imports ----


function fetchAllMessages(gameUserId) {
    return async dispatch => {
        try {
            const result = await InboxService.fetchAllMessages(gameUserId);
            if (!result.isSuccess) {
                return;
            }

            const data = result.data;
            const hasAnyMessages = data.length > 0;
            await inboxDb.addMessages(data);
            const unreadMessagesIds = await inboxDb.getUnreadMessagesIds();

            dispatch({
                type: types.INBOX_FETCH_MESSAGES_SUCCESSFUL,
                unreadMessagesCount: unreadMessagesIds.length,
                unreadMessagesIds,
                hasAnyMessages,
            });
        } catch (error) {
            console.error(error);
        }
    };
}

function handleNewMessage(messages) {
    return async (dispatch, getState) => {
        try {
            if (Array.isArray(messages)) {
                inboxDb.addMessages(messages);
                const messageIds = messages.map(message => message.id);
                dispatch({ type: types.INBOX_MESSAGES_NEW, messageIds });
            } else {
                inboxDb.addMessage({ ...messages });
                dispatch({ type: types.INBOX_MESSAGES_NEW, messageId: messages.id });
            }
        } catch (error) {
            console.error(error);
        }
    };
}

function handleNewMonthNotifications(messages) {
    return async (dispatch, getState) => {
        try {
            inboxDb.addMessages(messages);
            const unreadMessagesIds = messages.map((message) => message.id);
            dispatch({ type: types.INBOX_NEW_MONTH_MESSAGES, unreadMessagesIds: unreadMessagesIds });
        } catch (error) {
            console.error(error);
        }
    };
}

function readMessage(messageId) {
    return async (dispatch, getState) => {
        try {
            const gameUserId = gameSelectors.getGameId(getState());
            const result = await InboxService.readMessage(gameUserId, messageId);

            if (!result.isSuccess) {
                return;
            }

            
            inboxDb.markAsRead(messageId);

            dispatch({ type: types.INBOX_MESSAGES_READ, messageId });
        } catch (error) {
            console.error(error);
        }
    };
}

function processUpdate() {
    return { type: types.INBOX_MESSAGES_PROCESSED_UPDATE };
}

function readAllMessages() {
    return { type: types.INBOX_READ_ALL_MESSAGES };
}

export {
    handleNewMessage,
    handleNewMonthNotifications,
    readMessage,
    fetchAllMessages,
    processUpdate,
    readAllMessages,
};
